import React, { useEffect } from 'react';
import { Link } from "gatsby"
import $ from "jquery"

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"
import Img from "gatsby-image"

import Toplogo from '../images/toplogo.png'



const IndexPage = () => {
  useEffect(() => {
    const fotterPaddingBottom = Number($('footer').css('padding-bottom').replace('px', ''))
    var coverpos = 0;
    window.addEventListener('scroll', (e) => {
      if (document.getElementById('entrance')) {
        const point = $(window).width() < 480 ? '20' : '100'
        if ($(window).scrollTop() > point) {
          $('footer.white').css({
            'backdrop-filter': 'blur(4px)'
          })
        } else {
          $('footer.white').css({
            'backdrop-filter': 'none'
          })
        }
        coverpos = $(window).scrollTop() - $('#entrance').offset().top - 72 - fotterPaddingBottom - 4 < 0
          ? 0
          : ($(window).scrollTop() - $('#entrance').offset().top - 72 - fotterPaddingBottom - 4) / 14 > 1
            ? 1
            : ($(window).scrollTop() - $('#entrance').offset().top - 72 - fotterPaddingBottom - 4) / 14
        if (coverpos < 1 && coverpos > 0) {
          $('footer.white').find('p').css({
            'background': 'linear-gradient(#ffffff ' + (1 - coverpos) * 100 + '%, #6A33FB ' + coverpos * 100 + '%)',
            '-webkit-background-clip': 'text',
            '-webkit-text-fill-color': 'transparent'
          })
          $('footer.white').find('img.purple').css({
            'height': 20 * coverpos,
          })
        } else if ($(window).scrollTop() - $('#entrance').offset().top - 72 - fotterPaddingBottom - 4 < 0) {
          $('footer.white').find('p').css({
            'background': 'linear-gradient(#ffffff 100%, #6A33FB 0%)',
            '-webkit-background-clip': 'text',
            '-webkit-text-fill-color': 'transparent'
          })
          $('footer.white').find('img.purple').css({
            'height': 20 * coverpos,
          })
        } else if (($(window).scrollTop() - $('#entrance').offset().top - 72 - fotterPaddingBottom - 4) / 14 > 1) {
          $('footer.white').find('p').css({
            'background': 'linear-gradient(#6A33FB 0%, #6A33FB 100%)',
            '-webkit-background-clip': 'text',
            '-webkit-text-fill-color': 'transparent'
          })
          $('footer.white').find('img.purple').css({
            'height': 20 * coverpos,
          })
        }
      }
    });
    $('footer').find('a').on('mouseover', function () {
      if ($(window).scrollTop() > 100) {
        $(this).find('p').css({
          'background': 'linear-gradient(#75ffd4 0%, #75ffd4 100%)',
          '-webkit-background-clip': 'text',
        })
      } else {
        $(this).find('p').css({
          'color': '#ffffff'
        })
      }
    })
    $('footer').find('a').on('mouseout', function () {
      if (coverpos == 1) {
        $(this).find('p').css({
          'background': 'linear-gradient(#6A33FB 0%, #6A33FB 100%)',
          '-webkit-background-clip': 'text',
        })
      } else {
        $(this).find('p').css({
          'background': 'linear-gradient(#ffffff 0%, #ffffff 100%)',
          '-webkit-background-clip': 'text',
        })

      }
    })

    // .mouseout(function () {
    //   $(this).find('p').css({
    //     'color': ''
    //   })
    // })
  }, []);
  return (
    <Layout page="home">
      <SEO title="Home" />

      <div className={"contents top"}>
        <div className="cover">
          <img src={Toplogo} className={'toplogo'} />
        </div>
        <div className={"entrance"} id="entrance" >
          <Link to="/artists/">
            <Image src={'sweep-space-surface_holizontal_white.svg'} className="ssslogo" />
          </Link>
          <p>多摩美術大学 美術学部<br className={"mobileBr"} /> 情報デザイン学科 メディア芸術コース<br /> 2020 年度 卒業制作ウェブ図録</p>
        </div>
        <div className={"statement"}>
          <div className={"statement_wrap"}>
            <p className={"title"}>はじめに</p>
            <p>
              隔たれていた「私 / 公」空間が、ビデオ通話によってばらばらに接続されるようになったこと。<br />
          国境が閉じ、誰もいなくなった工業地帯では自然が回復したこと。<br />
          毎日が、延々と続くループのなかに置かれたこと。<br />
          遅延性のウイルスが、細胞に入り込み、私そのものを変容させてしまったのではないかと想像したことー 。<br />
              <br />
          今年私たちにもたらされた変化は、生活や身体に浸透することで、個々の私的な Space（時空間）、細胞やアイデンティティのSurface（境界面）にいたるまで、その姿を変容させていきました。<br />
              <br />
          押し流され、広がり、輪郭を変えて動き出すものたち。<br />
          本展が、Sweepする（急速に広がる）さまざまな力の均衡のもと、無数の形へと拡散してゆくSpace（時空間）/ そしてSurface（境界面) のいまについて、共に思索する機会となれば幸いです。<br />
            </p>
            <p className={"foot"}>
              多摩美術大学美術学部情報デザイン学科メディア芸術コース<br />
          2020年度卒業制作展「Sweep - Space - Surface」<br />
          実行委員会
        </p>
          </div>
        </div>
      </div>
    </Layout >
  )
}

export default IndexPage
